import React from 'react'
import { HOW_IT_WORKS_STEPS } from '../data/howItWorks'
import { useHowItWorksScroll } from '../hooks/useHowItWorksScroll'
import HowItWorksCopyPanel from './HowItWorksCopyPanel'
import ChatStory from './phone-stories/ChatStory'
import ScreenshotStory from './phone-stories/ScreenshotStory'

const HowItWorksSection: React.FC = () => {
  const { sectionRef, stageRef, phoneColumnRef, activeStep, scrollToStep } = useHowItWorksScroll(HOW_IT_WORKS_STEPS.length)

  return (
    <section ref={sectionRef} className="v2-hiw-section" id="how-it-works">
      <div ref={stageRef} className="v2-hiw-stage">
        <div className="v2-hiw-stage__head">
          <div>
            <p className="v2-eyebrow">
              <i />
              How it works
            </p>
            <h2>
              Three steps to <em>hello.</em>
            </h2>
          </div>
          <div className="v2-hiw-dots">
            {HOW_IT_WORKS_STEPS.map((step, index) => (
              <button
                key={step.number}
                type="button"
                className="v2-hiw-dot"
                data-active={index === activeStep}
                aria-current={index === activeStep ? 'step' : undefined}
                aria-label={`Step ${step.number}: ${step.title}`}
                onClick={() => scrollToStep(index)}
              />
            ))}
          </div>
        </div>

        <div className="v2-hiw-content" data-shift={activeStep === 1}>
          <div className="v2-hiw-copy-column">
            {HOW_IT_WORKS_STEPS.map((step, index) => (
              <HowItWorksCopyPanel key={step.number} step={step} isActive={index === activeStep} />
            ))}
          </div>

          <div ref={phoneColumnRef} className="v2-hiw-phone-column">
            {HOW_IT_WORKS_STEPS.map((step, index) => (
              <div key={step.number} className="v2-hiw-panel v2-hiw-phone-panel" data-active={index === activeStep}>
                {step.chat ? (
                  <ChatStory chat={step.chat} label={step.screenshotLabel} isActive={index === activeStep} />
                ) : (
                  <ScreenshotStory src={step.screenshotSrc ?? ''} label={step.screenshotLabel} isActive={index === activeStep} pulses={step.pulses} />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default HowItWorksSection
